import { Component, input } from '@angular/core';
import { faInfoCircle, faExclamationCircle, faCamera } from '@fortawesome/free-solid-svg-icons';
import { MainCouranteElement } from '../../main-courante-element.interface';
import { Declaration } from 'src/app/entities/vacation/declaration.model';
import { IVacation } from 'src/app/entities/vacation/vacation.interface';
import { ICreneauInter } from 'src/app/entities/creneaux/creneau-inter.interface';
import { LevelAlerte } from 'src/app/entities/alerte/level-alerte.model';

@Component({
  selector: 'in2-item-card-declaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.scss'],
  standalone: false,
})
export class MainCouranteDeclarationComponent implements MainCouranteElement {
  readonly declaration = input.required<Declaration>();
  readonly vacation = input.required<IVacation>();
  readonly creneau = input.required<ICreneauInter>();

  public faInfoCircle = faInfoCircle;
  public faExclamationCircle = faExclamationCircle;
  public faCamera = faCamera;

  public isAnomalie(): boolean {
    return this.declaration().level >= LevelAlerte.WARNING;
  }
}
